var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyexit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4A4A4A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.833 14.514l3.034 5.905 1.71-.838-3.655-7.2.972-1.905 1.323 1.905h4.394v-1.905h-3.383L8.283 7.62H3.306l-2.217 4.343L2.8 12.8l1.672-3.276h1.75l-2.916 5.714H0v1.905h4.472zm3.889-6.895c1.09 0 1.945-.838 1.945-1.905 0-1.066-.856-1.904-1.945-1.904s-1.944.838-1.944 1.904c0 1.067.855 1.905 1.944 1.905z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.444 8.571h1.945V1.905h11.976v20.448H21.389v-8.067h-1.945v8.067H0v1.457h35V0H19.444z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.578 15.505l1.4 1.371L31.5 11.43l-5.522-5.45-1.4 1.371 3.228 3.124h-12.25v1.905h12.25z"
  }))));
}
export default SvgEmergencyexit;